import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FurnitureApplicantComponent } from './furniture-applicant.component';
import { FurnitureApplicantRoutingModule } from './furniture-applicant-routing.module';
import { ApplicantInfoModule } from 'src/app/components/controls/applicant-info/applicant-info.module';
import { ContactInfoModule } from 'src/app/components/controls/contact-info/contact-info.module';
import { AddressInfoModule } from 'src/app/components/controls/address-info/address-info.module';
import { LivingSituationInfoModule } from 'src/app/components/controls/living-situation-info/living-situation-info.module';
import { AgreementInfoModule } from 'src/app/components/controls/agreement-info/agreement-info.module';
import { AddressTimeInfoModule } from 'src/app/components/controls/address-time-info/address-time-info.module';
import { LoadingSpinnerModule } from 'src/app/components/loading-spinner/loading-spinner.module';
import { RequestPurposeInfoModule } from 'src/app/components/controls/request-purpose-info/request-purpose-info.module';
import { ValidationTextModule } from 'src/app/components/validation-text/validation-text.module';
import { EmploymentStatusInfoModule } from 'src/app/components/controls/employment-status-info/employment-status-info.module';

@NgModule({
  declarations: [FurnitureApplicantComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FurnitureApplicantRoutingModule,
    ApplicantInfoModule,
    ContactInfoModule,
    AddressInfoModule,
    EmploymentStatusInfoModule,
    LivingSituationInfoModule,
    AddressTimeInfoModule,
    AgreementInfoModule,
    LoadingSpinnerModule,
    RequestPurposeInfoModule,
    ValidationTextModule,
  ],
})
export class FurnitureApplicantModule {}
